/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .factory('CommonUtils', function ($q) {
            var CommonUtils = {};

            CommonUtils.clone = function (source) {
                var target = {};
                if (source) 
                    angular.extend(target, source);
                
                return target;
            };

            CommonUtils.getScopePath = function ($scope, path) {
                if (path.indexOf('.') != -1) {
                    return path.substring(0, path.lastIndexOf('.'));
                }
                return path;
            };

            CommonUtils.getScopeName = function ($scope, path) {
                if (path.indexOf('.') != -1) 
                    return path.substring(path.lastIndexOf('.') + 1);

                return path;
            };

            CommonUtils.getScopeObject = function ($scope, path) {
                var pathParts = (path || '').split('.');
                if (pathParts == 0) {
                    throw new Error('path not valid on CommonUtils.getScopeObject');
                }
                else {
                    if (pathParts.length == 1) {
                        if ($scope[path] === undefined)
                            $scope[path] = null;

                        return $scope[path];
                    }
                    else {
                        var lastPart = pathParts.pop();
                        var inScope = $scope;

                        $(pathParts).each(function (i, item) {

                            if (inScope === null)
                                inScope = {};

                            if (inScope[item] === undefined)
                                inScope[item] = {};

                            inScope = inScope[item];
                        });

                        if (inScope === null)
                            inScope = {};

                        inScope[lastPart] = inScope[lastPart] || {};
                        return inScope[lastPart];
                    }
                }
            };

            return CommonUtils;
        });

})();
             